var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'equal-grid-container': _vm.isEqualSizes,
    'dynamic-grid-container': !_vm.isEqualSizes,
  }},[_vm._t("1"),_vm._t("2"),_vm._t("3"),_vm._t("4")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }